import { Theme, SxProps } from '@mui/material';
import { NumberInput as RaNumberInput, NumberInputProps as RaNumberInputProps } from 'react-admin';
import { fieldWidth } from 'themes/layout';

export type NumberInputProps = RaNumberInputProps & { shrink?: boolean };

const defaultSx: SxProps<Theme> = {
  '&.MuiFormControl-root': {
    marginTop: 0,
    marginBottom: 0,
  },
  '.MuiFormHelperText-root': {
    marginTop: 0,
  },
  ...fieldWidth.medium,
};

export const NumberInput: React.FC<NumberInputProps> = ({
  sx,
  InputLabelProps,
  shrink = true,
  ...restProps
}: NumberInputProps) => (
  <RaNumberInput
    InputLabelProps={{ shrink: shrink || undefined, ...InputLabelProps }}
    sx={{ ...defaultSx, ...sx }}
    {...restProps}
  />
);
